<template>
  <div class="box">
    <img class="imgs" v-lazy="url"/>
    <Suspension bottom="36px" desc="回首页" img="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/home.svg" @share="goHome"/>
  </div>
</template>
<script>
import Suspension from '../../components/suspension'
import { goHomePath } from '../../utils/power'
export default {
  components: {
    Suspension
  },
  data () {
    return {
      url: ''
    }
  },
  created () {
    const { url } = this.$route.query
    this.url = url
  },
  methods: {
    goHome () {
      this.$router.push({
        path: goHomePath()
      })
    }
  },
  computed: {
    getTarbarAuth () {
      return this.$store.getters['tarbarAuth/getAuth']
    }
  }
}
</script>
<style lang="scss" scoped>
.box {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .imgs {
    max-width: 100%;
    max-height: 100%;
  }
}
</style>
